import { ImageIcon } from "../../assets/icons";
import { Text } from "../text/text";
import styles from "./textEditor.module.css";

export const AtomicImage = ({ block, contentState }) => {
    const entityKey = block.getEntityAt(0);
    if (!entityKey) return null;

    const entity = contentState.getEntity(entityKey);
    if (entity.getType() !== "IMAGE") return null;

    const src = entity.getData().src;
    if (!src) return null;

    return (
        <div className={styles.atomic_image_container}>
            <Text as="div" variant="bodyStrong" className={styles.atomic_title}>
                Изображение
            </Text>

            <ImageIcon width="24" height="24" />
        </div>
    );
}